import { trim, strSlug } from '../helpers/strSlug';

export default function initSubnavigation() {
    // Disable in edit mode

    const $families = document.querySelectorAll('.family');
    $families.forEach($family => {
        const $subnav = $family.querySelector('.sub-navigation');

        if (!$subnav) {
            return;
        }

        const $subnavContainer = $subnav.querySelector('.container');
        const $sections = $family.querySelectorAll('.family-section');

        const defaultSubnavOffset = $subnav.offsetTop + 64;

        window.onscroll = () => {
            const windowScrollOffset = window.scrollY;
            if ($subnav) {
                if (windowScrollOffset > defaultSubnavOffset) {
                    if (!$subnav.classList.contains('is-floating')) {
                        $subnav.classList.add('is-floating');
                    }
                } else {
                    $subnav.classList.remove('is-floating');
                }
            }
        };

        const handleSubnavigationChange = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
                    if ($subnav.querySelector('.is-active')) {
                        $subnav.querySelector('.is-active').classList.remove('is-active');
                    }
                    const id = entry.target.getAttribute('id');
                    $subnav.querySelector(`[href="#${id}"]`).classList.add('is-active');
                }
            });
        };

        const observer = new IntersectionObserver(handleSubnavigationChange, {
            threshold: 0.25,
        });

        let $navigation = document.createElement('nav');
        let $ul = document.createElement('ul');

        $subnavContainer.innerHTML = '';
        $subnavContainer.appendChild($navigation);
        $navigation.appendChild($ul);

        $sections.forEach($section => {
            const sectionTitle = $section.querySelectorAll('.bigger');
            let linkText;
            if (sectionTitle.length != 0) {
                linkText = sectionTitle[0].innerText;
            }

            if (linkText === undefined) {
                linkText = $section.dataset.navigationText;
                if (!linkText || !linkText.length) {
                    return;
                }
            }
            delete $section.dataset.navigationText;

            const linkHref = $section.id;
            if (linkHref === undefined || linkHref === null || linkHref === '') {
                return;
            }

            const $item = document.createElement('li');
            const $link = document.createElement('a');

            $link.innerText = trim(linkText);
            $link.href = `#` + linkHref;

            $link.addEventListener(
                'click',
                event => {
                    event.preventDefault();
                    let navigationHeight = 64;
                    let scrolledElement = document.getElementById(linkHref);

                    if ($subnav.classList.contains('is-floating') && $sections[0].id === linkHref) {
                        navigationHeight = 0;
                    } else if (!$subnav.classList.contains('is-floating') && $sections[0].id !== linkHref) {
                        navigationHeight = 64;
                    }

                    console.log(navigationHeight);

                    const y = scrolledElement.getBoundingClientRect().top + window.scrollY - navigationHeight;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                },
                false
            );

            $link.classList.add('link');
            $link.classList.add('has-smooth-scroll');

            $ul.appendChild($item);
            $item.appendChild($link);
            observer.observe($section);
        });
    });
}
